//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.InspectionMoveBuilder.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
import "../no/SelectPoint.js";
import "../no/SelectObject.js";
let d=[[[1,"ApproachDist",0,"CAM.InheritableDoubleBuilder",0],[0,"DepthDistance",1,0],[0,"DepthMethod",1,0],[0,"I",1,0],[0,"J",1,0],[0,"K",1,0],[0,"PointTypeEnum",1,0],[1,"RetractDist",0,"CAM.InheritableDoubleBuilder",0],[1,"SelectExistingPoint",0,"SelectPoint",0],[0,"TargetPoint",1,"Point",0],[0,"X",1,0],[0,"Y",1,0],[0,"Z",1,0]],[[[],"UpdateParams",{},0,0]],[]];
SPLM.CAM.InspectionMeasurePointBuilder = class extends SPLM.CAM.InspectionMoveBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.InspectionMeasurePointBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.InspectionMeasurePointBuilder.PointTypes = Object.freeze({
    "ExistingPoint" : "ExistingPoint", "CursorLocation" : "CursorLocation", "PointConstructor" : "PointConstructor"});

export default SPLM;